@let isLoader = isLoading | async;
@if (isLoader) {
  <div class="spinner-overlay">
    <div class="spinner"></div>
  </div>
}
